module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid-filter"
  }, [_c('p', {
    staticClass: "column-title"
  }, [_vm._v(_vm._s(_vm.columnTitle))]), _c('ed-input', {
    ref: 'input',
    attrs: {
      "placeholder": _vm.t("Search") + " " + _vm.columnTitle,
      "search": ""
    },
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  }), _c('ed-button', {
    staticClass: "btn btn-actionbar",
    on: {
      "click": _vm.apply
    }
  }, [_vm._v(_vm._s(_vm.t("Apply")))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d2f2d2ca","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Grid/filters/text.vue
// module id = FLzU
// module chunks = 13 14